export default "__VITE_ASSET__DVCVlQZU__"